// extracted by mini-css-extract-plugin
export var standaloneTable = "_he-0";
export var standaloneTableWithBodyFill = "_he-1";
export var withExtraHeader = "_he-2";